import Message from './message';
export default class PageMessage extends Message {
    fire(category, page, properties, options) {
        this.call({
            properties,
            apiMethod: 'page',
            name: page,
            category,
        }, options);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZS1tZXNzYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NkcC9tZXNzYWdlcy9wYWdlLW1lc3NhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxPQUFPLE1BQU0sV0FBVyxDQUFDO0FBSWhDLE1BQU0sQ0FBQyxPQUFPLE9BQU8sV0FBWSxTQUFRLE9BQXlCO0lBQ2hFLElBQUksQ0FDRixRQUFpQixFQUNqQixJQUFhLEVBQ2IsVUFBdUIsRUFDdkIsT0FBbUM7UUFFbkMsSUFBSSxDQUFDLElBQUksQ0FDUDtZQUNFLFVBQVU7WUFDVixTQUFTLEVBQUUsTUFBTTtZQUNqQixJQUFJLEVBQUUsSUFBSTtZQUNWLFFBQVE7U0FDVCxFQUNELE9BQU8sQ0FDUixDQUFDO0lBQ0osQ0FBQztDQUNGIn0=